import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { currencyFormatNoDecimals } from "../../../../../../components/NewDetail/calculations/utils";

const Accessory = (props) => {
  const { accessory } = props;
  if (!accessory) return null;

  return (
    <Box {...props}>
      <Typography variant="h6">
        Accessories / MISC -{" "}
        {currencyFormatNoDecimals(Math.round(Number(accessory.totalSellPrice)))}
      </Typography>
      <TableContainer component={Box}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">Quantity</TableCell>
              <TableCell align="right">Unit Of Measure</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {accessory.items.map((item, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {item.name}
                </TableCell>
                <TableCell align="right">{item.quantity}</TableCell>
                <TableCell align="right">{item.unitOfMeasure}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Accessory;
